/* istanbul ignore file */
import { createStore } from "redux";
import enhancer from "./enhancer";
import reducer from "./modules";

const store = createStore(reducer, enhancer);

if (module.hot && process.env.NODE_ENV !== "production") {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept("./modules", () => {
    const nextReducers = require("./modules").default;

    store.replaceReducer(nextReducers);
  });
}

export default store;
